import * as React from "react";
import Button from "@sproutsocial/seeds-react-button";
import Icon from "@sproutsocial/seeds-react-icon";
import { usePanelContext } from "./PanelContext";
import type { TypePanelCloseButtonProps } from "./PanelTypes";

export const PanelCloseButton = (props: TypePanelCloseButtonProps) => {
  const panelContext = usePanelContext();

  if (props.render) {
    return props.render(panelContext) ?? null;
  }

  return (
    <Button
      appearance="pill"
      aria-label={panelContext.closeButtonLabel}
      onClick={panelContext.closePanel}
      {...props}
    >
      {props.children || (
        <Icon aria-hidden name="collapse-panel-right-outline" />
      )}
    </Button>
  );
};

PanelCloseButton.displayName = "Panel.CloseButton";
